import React, { Component } from 'react';
import {
    Grid,
    Card,
    CardContent,
    Button,
    Pagination
} from '@mui/material'
import moment from 'moment'

class ShowOrders extends Component {
    constructor() {
        super();
    }
    render() {
        return (
            <>
                <Grid container
                    sx={{
                        width: '100%',
                        p: 3,
                        fontFamily: 'sans-serif'
                    }}
                >
                    <Grid item xs={12}
                        sx={{
                            color: '#050A4E',
                            fontWeight: 600,
                            mb: 1,
                            ml: 2,
                            fontSize: 16
                        }}
                    >
                        Your Orders
                    </Grid>
                    <Grid item xs={12}
                        sx={{
                            mb: 3,
                            ml: 2,
                            fontWeight: 500,
                            fontSize: 14
                        }}
                    >
                        {this.props.orderCount ?
                            <span>Order Count: <span style={{ fontWeight: 600 }}>{this.props.orderCount}</span></span>
                            : null
                        }
                    </Grid>
                    {
                        this.props.appointments?.map((appointment) => {
                            return (
                                <Grid item xs={12}
                                    sx={{
                                        mb: 3,
                                        fontSize: 14
                                    }}
                                >
                                    <Grid container
                                        sx={{
                                            width: '100%',
                                            borderTopLeftRadius: 24,
                                            borderTopRightRadius: 24,
                                            borderBottom: '1px solid #BDBDBD',
                                            p: 2,
                                            pl: 3,
                                            boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)',
                                            background: '#F0F0F0'
                                        }}
                                    >
                                        <Grid item xs={3}>
                                            <div className='orderHeaderTitle' >Order Placed</div>
                                            <div className='ohd-value'>{appointment?.orderPlaced ? moment(appointment.orderPlaced).format('DD MMM YYYY') : '-'}</div>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <div className='orderHeaderTitle'>Order ID</div>
                                            <div className='ohd-value'>{appointment?.orderID}</div>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <div className='orderHeaderTitle'>Mobile Number</div>
                                            <div className='ohd-value'>{appointment?.phoneNumber}</div>
                                        </Grid>
                                        <Grid item xs={3}
                                            style={{ display: 'flex', justifyContent: 'flex-end' }}
                                        >
                                            <Button sx={{
                                                ml: { xs: 0, sm: 2 },
                                                px: 3,
                                                boxShadow: '0 0 4px rgba(0,0,0,0.20)',
                                                mt: { xs: 2, sm: 0 },
                                                background: '#FFFFFF',
                                                fontSize: 14
                                            }}
                                                onClick={() => this.props.handleViewHistory(appointment)}
                                            > View History</Button>
                                        </Grid>
                                    </Grid>
                                    <Card sx={{
                                        width: '100%',
                                        borderBottomLeftRadius: 24,
                                        borderBottomRightRadius: 24,
                                    }}>
                                        <CardContent>
                                            <div>
                                                <span className='od-title'>Name: </span>
                                                <span className='od-value'>{appointment?.name}</span>
                                            </div>
                                            <div>
                                                <span className='od-title'>Address: </span>
                                                <span className='od-value'>{appointment?.address}</span>
                                            </div>
                                            <div>
                                                <span className='od-title'>Order Details: </span>
                                                <span className='od-value'>
                                                    {
                                                        appointment?.orderedItems?.length > 0 ?
                                                            appointment.orderedItems.reduce((acc, curr, idx) => {
                                                                acc = acc + curr
                                                                if (idx != appointment.orderedItems.length - 1)
                                                                    acc += ", "
                                                                return acc
                                                            }, "") :
                                                            "Not Available"

                                                    }
                                                </span>
                                            </div>
                                            <div>
                                                <span className='od-title'>Status: </span>
                                                {
                                                    [86, 87, 169, 57].includes(appointment?.statusId) ?
                                                        <span className='od-value od-deliveredStatus'>{appointment?.status}</span> :
                                                        ([27, 28, 43, 5].includes(appointment?.statusId) ?
                                                            <span className='od-value od-cancelStatus'>{appointment?.status}</span> :
                                                            <span className='od-value od-otherStatus'>{appointment?.status}</span>)
                                                }
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )
                        })
                    }

                    {
                        <Grid item xs={12}
                            style={{ display: 'flex', justifyContent: 'center' }}
                        >
                            <Pagination
                                count={this.props.isNextPageAvailable ? this.props.page + 1 : this.props.page}
                                color="primary"
                                onChange={(event, page) => this.props.handlePageChanged(event, page)}
                                page={this.props.page}
                            />
                        </Grid>
                    }
                </Grid>
            </>
        );
    }
}

export default ShowOrders;